import { useState } from 'react';
import { Btn } from '../components/Btn.tsx';
import { ErrorMessage } from '../components/ErrorMessage.tsx';
import { Field, TextArea } from '../components/Field.tsx';
import { Modal } from '../components/Modal.tsx';
import type { Question } from '../lib/types.ts';

// Standalone reviewer comment: saved against the submission without changing its
// status. Visible to the company and queued into the change digest.
export function CommentModal({
  question,
  pending,
  error,
  onClose,
  onSubmit,
}: {
  question: Question;
  pending: boolean;
  error: Error | null;
  onClose: () => void;
  onSubmit: (comment: string) => void;
}) {
  const [comment, setComment] = useState('');
  return (
    <Modal
      open
      title={`Comment — ${question.label}`}
      size="md"
      onClose={onClose}
      footer={
        <>
          <Btn size="sm" variant="ghost" onClick={onClose}>
            Cancel
          </Btn>
          <Btn
            size="sm"
            variant="primary"
            disabled={!comment.trim()}
            loading={pending}
            onClick={() => onSubmit(comment.trim())}
          >
            Save comment
          </Btn>
        </>
      }
    >
      <div className="space-y-3">
        <Field label="Comment for the company" required>
          <TextArea
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            placeholder="Leave a note for the company without changing the status…"
          />
        </Field>
        {error && <ErrorMessage error={error} />}
      </div>
    </Modal>
  );
}
